module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav-list"
  }, [_vm._t("subListMobile"), _vm._l((_vm.items), function(item, index) {
    return _c('list-item', {
      key: index,
      staticClass: "nav-item",
      attrs: {
        "text": item.text,
        "items": item.children,
        "to": item.to,
        "external": item.external,
        "callback": item.callback,
        "level": _vm.level,
        "max-level": _vm.maxLevel
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dce32f6","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/nav/private/SubList.vue
// module id = e322cb1561f768a8d467
// module chunks = 0